import { LOAN_APPLICATION_STATE } from "../../../../../../config/config";

export const areAllLoanApplicationsProcessed = (loanApplications) => {
  if (!loanApplications) return false;
  if (loanApplications.length === 0) return false;
  if (
    loanApplications.every(
      (loanApplication) =>
        loanApplication.lender_fields.loan_application_status.state ===
          LOAN_APPLICATION_STATE.PROCESSED ||
        loanApplication.lender_fields.loan_application_status.state ===
          LOAN_APPLICATION_STATE.SELECTED
    )
  ) {
    return true;
  }
  return false;
};
